import * as loginTypes from './loginTypes';
import { LOGINPAGE, FPASSPAGE } from './constants';

const initialState = {
  loginPage: LOGINPAGE,
  token: null,
  userInfo: {
    personId: null,
  },
  flow: 'login',
  isValidated: false,
  userRoles: {
    applicant: false,
    corpClient: false,
    eyPro: false,
    eyAdmin: false,
  },
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case loginTypes.POST_LOGIN_PENDING:
      return { ...state, loginStatus: 'PENDING' };
    case loginTypes.POST_LOGIN_SUCCESS:
      return {
        ...state,
        loginStatus: 'SUCCESS',
        ...action.data,
        flow: 'login',
      };
    case loginTypes.POST_LOGIN_FAILURE:
      return { ...state, loginStatus: 'FAILURE', userSuccess: false, ...action.error };
    case loginTypes.POST_FORGOT_PASSWORD_PENDING:
      return { ...state, forgotPasswordStatus: 'PENDING' };
    case loginTypes.POST_FORGOT_PASSWORD_SUCCESS:
      return { ...state, forgotPasswordStatus: 'SUCCESS', ...action.data, flow: 'forgot-password' };
    case loginTypes.POST_FORGOT_PASSWORD_FAILURE:
      return { ...state, forgotPasswordStatus: 'FAILURE', ...action.error };
    case loginTypes.CLEAR_ERRORS:
      return {
        ...state,
        error: null,
        numberAttempts: 0,
        userInfo: {
          personId: null,
        },
        returnTologin: false,
      };
    case loginTypes.CLEAR_LOGIN_ATTEMPTS:
      return {
        ...state,
        error: null,
        numberAttempts: 0,
      };
    case loginTypes.RETURN_TO_LOGIN:
      return { ...state, returnTologin: true };
    case loginTypes.VALIDATE_CODE_PENDING:
      return { ...state, validateCodeStatus: 'PENDING', authCode: action.code };
    case loginTypes.VALIDATE_CODE_SUCCESS:
      return { ...state, loginStatus: 'SUCCESS', validateCodeStatus: 'SUCCESS', ...action.data };
    case loginTypes.VALIDATE_CODE_FAILURE:
      return { ...state, loginStatus: 'FAILURE', validateCodeStatus: 'FAILURE', pinSuccess: false, ...action.error };
    case loginTypes.GOTO_FORGOT_PASSWORD:
      return { ...state, loginPage: FPASSPAGE };
    case loginTypes.GOTO_LOGIN:
      return { ...state, loginPage: LOGINPAGE };
    case loginTypes.USER_VALIDATE_SUCCESS:
      const { userInfo } = action.data;
      return { ...state, userInfo };
    case loginTypes.RESEND_CODE_PENDING:
      return { ...state, resendCodeMessage: 'Sending...' };
    case loginTypes.RESEND_CODE_SUCCESS:
      return { ...state, resendCodeMessage: action.message };
    case loginTypes.RESEND_CODE_FAILURE:
      return { ...state, ...action.error };
    case loginTypes.RESET_PASSWORD_PENDING:
      return { ...state, resetPasswordStatus: 'Pending' };
    case loginTypes.RESET_PASSWORD_SUCCESS:
      return { ...state, resetPasswordStatus: 'Success', ...action.data };
    case loginTypes.RESET_PASSWORD_FAILURE:
      return { ...state, ...action.error };
    case loginTypes.UPDATE_USER_ROLES: {
      const { userRoles } = action;
      return { ...state, isValidated: true, userRoles };
    }
    case loginTypes.SET_USER_FROM_SESSION: {
      return { ...state, ...action.data };
    }
    case loginTypes.CLEAR_SESSION: {
      return {
        ...state,
        token: null,
        userInfo: {
          personId: null,
        },
      };
    }
    case loginTypes.LOGOUT_SESSION: {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
};

export { initialState };
export default loginReducer;
